/**
 * WordPress dependencies
 */
import { store as CORE } from '@safe-wordpress/core-data';
import { _x } from '@safe-wordpress/i18n';

/**
 * External dependencies
 */
import { PremiumActionTypeDefinition } from '@nelio/forms/types';

/**
 * Internal dependencies
 */
import icon from './icon';

const action: PremiumActionTypeDefinition = {
	isPremium: true as const,
	isUnique: true,
	type: 'zapier-integration',
	label: _x( 'Zapier integration', 'text', 'nelio-forms' ),
	icon,
	canCurrentUserUse: ( select ) =>
		!! select( CORE ).canUser( 'create', 'users', '' ),
};

export default action;
